<div *ngIf="form" [formGroup]="form">
  <input class="w-100" #main [matDatepicker]="datePicker" formControlName="main" (focus)="onFocus()"
    (focusout)="onFocusOut($event)">
  <mat-datepicker #datePicker></mat-datepicker>
</div>